var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.892a4.108 4.108 0 100 8.215 4.108 4.108 0 000-8.215zm0 6.774a2.666 2.666 0 110-5.333 2.666 2.666 0 010 5.333z",
    fill: "#ACB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.23 7.73a.96.96 0 11-1.92 0 .96.96 0 011.92 0z",
    fill: "#ACB5BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c-2.173 0-2.445.01-3.299.048-.851.039-1.432.174-1.942.372a3.918 3.918 0 00-1.416.923c-.445.444-.719.89-.923 1.417-.198.509-.333 1.09-.372 1.941C4.01 9.555 4 9.827 4 12c0 2.172.01 2.445.048 3.298.039.851.174 1.433.372 1.942.205.526.478.972.923 1.417.445.445.89.718 1.417.923.509.197 1.09.333 1.942.371.853.04 1.125.049 3.298.049s2.445-.01 3.298-.049c.852-.038 1.434-.174 1.942-.371a3.918 3.918 0 001.417-.923c.445-.445.718-.891.923-1.417.198-.509.333-1.09.372-1.942.039-.853.048-1.126.048-3.298 0-2.173-.01-2.445-.048-3.299-.039-.851-.174-1.433-.372-1.942a3.918 3.918 0 00-.923-1.416 3.92 3.92 0 00-1.417-.923c-.51-.198-1.09-.333-1.942-.372C14.445 4.01 14.172 4 12 4zm0 1.441c2.136 0 2.389.009 3.232.047.78.036 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.282.24.705.275 1.485.039.843.047 1.097.047 3.233s-.008 2.389-.047 3.232c-.035.78-.165 1.204-.275 1.486-.145.373-.319.64-.598.92-.28.28-.547.453-.92.598-.282.11-.706.24-1.486.275-.843.039-1.096.047-3.232.047s-2.39-.008-3.233-.047c-.78-.035-1.203-.165-1.485-.275a2.482 2.482 0 01-.92-.598 2.474 2.474 0 01-.599-.92c-.11-.282-.24-.706-.275-1.486-.038-.843-.047-1.096-.047-3.232s.009-2.39.047-3.233c.036-.78.166-1.203.275-1.485.145-.374.319-.64.599-.92.28-.28.546-.454.92-.599.282-.11.705-.24 1.485-.275.844-.038 1.097-.047 3.233-.047z",
    fill: "#ACB5BD"
  })));
}

export default SvgInstagram;